import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { TokeetImage } from '@tv3/models/rental/tokeet-image'
import { loadRentalImagesComplete, RentalService } from '@tokeet-frontend/tv3-platform'
import { Store } from '@ngrx/store'
import { switchMap } from 'rxjs/operators'

export type RentalImageEnhanceRevertDialogData = {
  image: TokeetImage
}

@Component({
  selector: 'app-rental-image-enhance-revert-dialog',
  templateUrl: './rental-image-enhance-revert-dialog.component.html',
  styleUrls: ['./rental-image-enhance-revert-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class RentalImageEnhanceRevertDialogComponent {
  isReverting = false
  error: string = null

  constructor(
    public dialogRef: MatDialogRef<RentalImageEnhanceRevertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RentalImageEnhanceRevertDialogData,
    private rentalService: RentalService,
    private store: Store<any>
  ) {}

  close() {
    this.dialogRef.close()
  }

  revert() {
    this.isReverting = true

    const image = this.data.image
    const { enhanced: _enhanced, original, ...restMetadata } = image.metadata

    this.rentalService
      .editImage(image.id, {
        url: original.url,
        secure_url: original.secure_url,
        public_id: original.public_id,
        type: original.type,
        size: original.size,
        height: original.height,
        width: original.width,
        metadata: restMetadata,
      })
      .pipe(switchMap(() => this.rentalService.images(image.rentalId)))
      .subscribe({
        next: (images) => {
          this.store.dispatch(loadRentalImagesComplete({ update: { id: image.rentalId, changes: { images } } }))
          this.dialogRef.close()
        },
        error: () => {
          this.error = $localize`Failed to revert image. Please try again.`
          this.isReverting = false
        },
      })
  }
}
